// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_r-1";
export var movingGradient = "_r-4";
export var movingGradientBlock = "_r-2";
export var skeleton = "_r-0";
export var skeletonText = "_r-3";